module.exports = __webpack_public_path__ + "static/img/public_qrcode.79fa28d0.png";